import classNames from '@sindresorhus/class-names';
import {ElementType} from 'react';

import styles from './Text.module.scss';
import {TextComponentType, TextProps} from './TextProps';

export const TextComponent = <T extends ElementType = 'span'>(
  props: TextProps<T>,
) => {
  const {
    ref,
    as: Component = 'span',
    className,
    color = 'core-text-primary',
    typography,
    maxLines = 1,
    overflow,
    style = {},
    ...restProps
  } = props;

  if (overflow === 'ellipsis') {
    style.WebkitLineClamp = maxLines;
  }

  return (
    <Component
      className={classNames(
        className,
        typography && styles[`typography-${typography}`],
        styles.color,
        {
          [styles['overflow-ellipsis']]: overflow === 'ellipsis',
        },
      )}
      style={{...style, '--color': `var(--${color})`} as React.CSSProperties}
      ref={ref}
      {...restProps}
    />
  );
};

TextComponent.displayName = 'Text';

export const Text: TextComponentType = TextComponent;
